// jsdom cannot perform a real navigation, so tests stub this wrapper instead of window.location.
export function reloadPage(): void {
  window.location.reload();
}
